<div class="container-fluid mat-elevation-z2 rounded p-4">
    <h1 class="text-center">Api keys</h1>
    <div class="container">
        <mat-divider></mat-divider>
        <div *ngFor="let key of connectedUser.apiKeys" class="w-100 row">
            <mat-form-field class="mx-auto">
                <input matInput type="password" appearance="outline" [(ngModel)]="key.key" required disabled>
                <mat-icon class="icon" (click)="onDeleteApiKey(key.id)" matSuffix>delete</mat-icon>
                <mat-icon class="icon" (click)="copyKeyToClipboard(key)" matSuffix>content_paste</mat-icon>
            </mat-form-field>
        </div>

        <!-- Actions -->
        <div class="row d-flex justify-content-around">
            <button class="w-25" [disabled]="isLoading" (click)="onAddApiKey()" mat-raised-button color="primary">
                <span *ngIf="!isLoading"> Add </span>
                <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3"
                    class="mx-auto mat-spinner"></mat-spinner>
            </button>
        </div>
    </div>
</div>